const knownAliases = ['hlslo', 'hlsmed', 'iPhonewabsec', 'iPhonewab'];

// najde prvy stream launch code ktory ma alias z poradia 'hlslo' alebo 'hlsmed' alebo 'iPhonewabsec' alebo 'iPhonewab'
// ak nenajde nic throwne Error
// ocakavany format je nasledovny:
//
// <availableMediaFormats>
//     <mediaFormat id="1016">
//         <playerAlias>hlslo</playerAlias>
//         <stream>
//             <streamLaunchCode>
//                 <![CDATA[https://744133.akamaized.net/hls/live/716240/ch20/eerjgvgfou9n1s6o3m3xlbeko.m3u8?reportingKey=eventId-1576019_partnerId-5146&hdnea=st=1560952428~exp=1560952488~acl=/*/716240*~hmac=0554bffaac3197e16ee729f261c1400486e94b1fbbc2c95f91e3fea2a4b1684d&unique_id=b6ee4187a1199fc5c1b935f41d3d7c3e534c2784edae2cf228f9426a4e03cbbb043fa606]]>
//             </streamLaunchCode>
//         </stream>
//     </mediaFormat>
//     <mediaFormat id="1012">
//         <playerAlias>hlsmed</playerAlias>
//         <stream>
//             <streamLaunchCode>
//                 <![CDATA[https://744133.akamaized.net/hls/live/716240/ch20/sq3zasz40q5g1jw1nqekb4f37.m3u8?reportingKey=eventId-1576019_partnerId-5146&hdnea=st=1560952428~exp=1560952488~acl=/*/716240*~hmac=0554bffaac3197e16ee729f261c1400486e94b1fbbc2c95f91e3fea2a4b1684d&unique_id=a21f4ee18ee266618a7263052230d272e1d6325752647b0f9c51d1c1393076810938c54c]]>
//             </streamLaunchCode>
//         </stream>
//     </mediaFormat>
// </availableMediaFormats>

// TODO toto by vazne chcelo testy
function parsePerformXml(xml: string) {
    const document = new DOMParser().parseFromString(xml, 'text/xml');
    const playerAliases = document.getElementsByTagName('playerAlias');
    const launchCodes = {};
    for (let i = 0; i < playerAliases.length; i++) {
        const playerAlias = playerAliases[i];
        const alias = playerAlias.textContent.trim();
        launchCodes[alias] = (playerAlias.parentNode as Element)
            .getElementsByTagName('streamLaunchCode')[0]
            .textContent.trim();
    }

    for (let i = 0; i < knownAliases.length; i++) {
        const launchCode = launchCodes[knownAliases[i]];
        if (launchCode) {
            return launchCode;
        }
    }
    throw new Error('No available launch code');
}

export default parsePerformXml;

// const a = '<?xml version="1.0" encoding="UTF-8"?>\n' +
//     '<eventInfo serverTs="20190619135418" xmlns="http://www.performgroup.com/ns/liveVideo/EventInfo">\n' +
//     '<event id="1576019">\n' +
//     '<description><![CDATA[SOCCER: Côte d\'Ivoire v Zambia<BR>Not Available in Côte d\'Ivoire and Zambia\n' +
//     ']]></description>\n' +
//     '<contentTypeId>2</contentTypeId>\n' +
//     '<start feedTs="20190619114500" eventTs="20190619123000">19 Jun 2019 13:30</start>\n' +
//     '<finish eventTs="20190619144500">19 Jun 2019 15:45</finish>\n' +
//     '<startTimeZone>BST</startTimeZone>\n' +
//     '<location></location>\n' +
//     '<countryCode></countryCode>\n' +
//     '<thirdPartyEventId></thirdPartyEventId>\n' +
//     '</event>\n' +
//     '<availableMediaFormats> \n' +
//     '<mediaFormat id="1016">\n' +
//     '<playerAlias>hlslo</playerAlias>\n' +
//     '<stream>\n' +
//     '<streamLaunchCode>\n' +
//     '<![CDATA[https://744133.akamaized.net/hls/live/716240/ch20/eerjgvgfou9n1s6o3m3xlbeko.m3u8?reportingKey=eventId-1576019_partnerId-5146&hdnea=st=1560952428~exp=1560952488~acl=/*/716240*~hmac=0554bffaac3197e16ee729f261c1400486e94b1fbbc2c95f91e3fea2a4b1684d&unique_id=b6ee4187a1199fc5c1b935f41d3d7c3e534c2784edae2cf228f9426a4e03cbbb043fa606]]>\n' +
//     '</streamLaunchCode>\n' +
//     '</stream>\n' +
//     '</mediaFormat>\n' +
//     '<mediaFormat id="1012">\n' +
//     '<playerAlias>hlsmed</playerAlias>\n' +
//     '<stream>\n' +
//     '<streamLaunchCode>\n' +
//     '<![CDATA[https://744133.akamaized.net/hls/live/716240/ch20/sq3zasz40q5g1jw1nqekb4f37.m3u8?reportingKey=eventId-1576019_partnerId-5146&hdnea=st=1560952428~exp=1560952488~acl=/*/716240*~hmac=0554bffaac3197e16ee729f261c1400486e94b1fbbc2c95f91e3fea2a4b1684d&unique_id=a21f4ee18ee266618a7263052230d272e1d6325752647b0f9c51d1c1393076810938c54c]]>\n' +
//     '</streamLaunchCode>\n' +
//     '</stream>\n' +
//     '</mediaFormat>\n' +
//     '</availableMediaFormats>\n' +
//     '</eventInfo>';
//
// window.testParsePerformXml = function () {
//     console.log('code:', parsePerformXml(a));
// }
